import {CreateIssueButton} from '@github-ui/issue-create/CreateIssueButton'
import {RelayEnvironmentProvider} from '@github-ui/relay-environment'
import {useNavigate} from '@github-ui/use-navigate'

import {getIssuesRelayEnvironment} from './issues-relay-environment'

const LABEL = 'New issue'

/**
 * `CreateIssueButton` is still Relay-based, so it shares the dashboard's browser environment.
 * This wrapper can go once issue-create finishes migrating off Relay.
 */
export function NewIssueButton() {
  const environment = getIssuesRelayEnvironment()
  const navigate = useNavigate()

  return (
    <RelayEnvironmentProvider environment={environment}>
      <CreateIssueButton
        label={LABEL}
        navigate={url => navigate(url, {reloadDocument: true})}
        optionConfig={{
          showRepositoryPicker: true,
          showFullScreenButton: true,
        }}
      />
    </RelayEnvironmentProvider>
  )
}
